import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Backend } from '../../_models/backend';
import { Title } from '@angular/platform-browser';
import LanguageType = Backend.LanguageType;

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languages: LanguageType[] = [ 'EN' , 'DE', 'FR', 'ES', 'HU', 'SK', 'ZH' ]; // TODO add langs

  constructor(private translate: TranslateService, private titleService: Title) { }

  getLanguage(languageType: LanguageType | undefined | null): LanguageType {
    if (languageType != null && this.languages.includes(languageType)) {
      return languageType;
    }

    const browserLang = this.translate.getBrowserLang();
    if (browserLang === 'hu') {
      return 'HU';
    } else if (browserLang === 'de') { // TODO add langs
      return 'DE';
    } else if (browserLang === 'fr') {
      return 'FR';
    } else if (browserLang === 'zh') {
      return 'ZH';
    } else if (browserLang === 'es') {
      return 'ES';
    } else if (browserLang === 'sk') {
      return 'SK';
    }

    return 'EN';
  }

  changeLanguage(languageType: LanguageType | undefined | null): void {
    const lang = this.getLanguage(languageType);

    this.useLanguage(lang);
  }

  useLanguage(languageType: LanguageType): void {
    const lang = languageType.toLowerCase();
    this.translate.use(lang);

    // update page title
    // const title = languageType === 'HU' ? 'SEOS Diák' : 'SEOS Student';
    // this.titleService.setTitle(title);
  }
}
